exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".q-wrap.isReplayPc .vh-radio__input.is-disabled .vh-radio__inner,\n.q-wrap.isReplayPc .vh-checkbox__input.is-disabled .vh-checkbox__inner {\n  background-color: #fff;\n}\n.q-wrap.isReplayPc .vh-radio__input.is-disabled + span.vh-radio__label,\n.q-wrap.isReplayPc .vh-checkbox__input.is-disabled + span.vh-checkbox__label {\n  color: #c2c2c2;\n}\n.q-wrap.isReplayPc .vh-input.is-disabled .vh-input__inner {\n  background-color: #fff;\n  color: #c2c2c2;\n}\n", ""]);

// exports
